import React, {useState, useEffect, createContext} from 'react'
import { CssBaseline} from "@mui/material";
import { Navigate, Route, Routes, useLocation  } from "react-router-dom";
import Layout from "./Loja/scenes/layout/Index"
import LojaIndex from './Loja/scenes/lojaIndex/Index';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const GLOBAL_URL = process.env.REACT_APP_BASE_URL;


const theme = createTheme({
  typography: {
    fontFamily: 'Nunito", sans-serif',
  },
});

export const EnvContext = createContext();
const token = localStorage.getItem('token');

function SiteRoot() {

  const appUrl = GLOBAL_URL;
  
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  

  return (
    <div className="app">
        <ThemeProvider theme={theme}>
        <EnvContext.Provider value={{appUrl}}> 
        <CssBaseline />
        <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<LojaIndex/>} />
              <Route path="/*" element={<Navigate to="/" replace />}>
                          
              </Route>
            </Route>
        </Routes>
        </EnvContext.Provider>
        </ThemeProvider>
    </div>
  );
}

export default SiteRoot;

   
